import { take } from "rxjs/operators";
import {
  Customer,
  FetchUserLevelsDocument,
  UserLevel,
} from "src/generated-gql/graphql";
import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { FormGroup } from "@angular/forms";

import {
  SharedModule,
  CustomDetailComponent,
  DataService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import { Observable, map, combineLatest } from "rxjs";

@Component({
  standalone: true,
  selector: "user-level-setter",
  templateUrl: "./setter.component.html",
  imports: [SharedModule],
})
export class UserLevelSetterComponent implements CustomDetailComponent, OnInit {
  constructor(
    private dataService: DataService,
    private notiService: NotificationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.fetchLevels();
    combineLatest([this.availableLevels$, this.entity$]).subscribe(
      ([levels, entity]) => {
        if (levels && levels.length > 0) {
          this.currentLevel = levels[0];
          this.currentLevelId = levels[0].id;
        }

        if (entity) {
          if (typeof entity.customFields?.pointAccumulate === "number") {
            this.accuPoint = Number(entity.customFields.pointAccumulate.toFixed(2));
          }

          if (entity.customFields?.userLevel) {
            this.currentLevelId = entity.customFields.userLevel.id;
            this.currentLevel = entity.customFields.userLevel;
          }

          if (typeof entity.customFields?.moneySpent === "number") {
            this.moneySpent = entity.customFields.moneySpent;
          }

          // A customer is bound to a single currency, so the "Spent" figure is
          // in the currency of their orders. Read it from the loaded orders.
          const orders = (entity as any)?.orders?.items ?? [];
          const orderWithCurrency = orders.find((o: any) => !!o?.currencyCode);
          if (orderWithCurrency?.currencyCode) {
            this.currencyCode = orderWithCurrency.currencyCode;
          }
        }

        this.cdr.detectChanges();
      }
    );
  }

  entity$: Observable<Customer>;
  detailForm: FormGroup;
  currentLevel: UserLevel;
  currentLevelId: string;
  accuPoint: number = 0;
  moneySpent: number = 0;
  currencyCode: string = "";
  availableLevels$: Observable<UserLevel[]>;

  fetchLevels() {
    this.availableLevels$ = this.dataService
      .query(FetchUserLevelsDocument)
      .single$.pipe(
        take(1),
        map((result) => [...result.userLevels.items])
      );
  }

  setLevel(event: any) {
    if (event === "0") {
      this.entity$.pipe(take(1)).subscribe((entity) => {
        this.dataService.customer
          .updateCustomer({
            id: entity.id,
            customFields: {
              userLevel: null,
            },
          })
          .pipe(take(1))
          .subscribe(() => {
            this.currentLevelId = "0";
            this.notiService.success("Customer level updated");
          });
      });
      return;
    }
    this.availableLevels$
      .pipe(
        map((levels) => levels.find((level) => level.id === event)),
        take(1)
      )
      .subscribe((level) => {
        this.entity$.pipe(take(1)).subscribe((entity) => {
          this.dataService.customer
            .updateCustomer({
              id: entity.id,
              customFields: {
                userLevel: level,
              },
            })
            .pipe(take(1))
            .subscribe((result) => {
              this.currentLevelId = level!.id;
              this.notiService.success("Customer level updated");
            });
        });
      });
  }

  create() {}

  update() {}
}
